
import './App.css';
import {BrowserRouter as Router, Routes,Route, ScrollRestoration} from 'react-router-dom'
import RequireAuth from './components/RequireAuth';

import { pdfjs } from 'react-pdf';

import {PDFWORKER_URL} from './config'

import Layout from './components/Layout';
import Login from './components/Login';
import Home from './components/Home';
import Register from './components/Register';
import EmployeesList from './components/EmployeesList';
import Employee from './components/Employee';
import NewEmployee from './components/NewEmployee';
import NewStockitem from './components/NewStockitem';
import PdfView from './components/PdfView';
import Upload from './components/Upload';
import MyUploader from './components/MyUploader';
import DocumentsList from './components/DocumentsList';
import Stock from './components/Stock';
import StockitemsList from './components/StockitemsList';
import Stockitem from './components/Stockitem';
import WarehouseList from './components/WarehouseList';
import NewWarehouse from './components/NewWarehouse';
import Warehouse from './components/Warehouse';
import Transaction from './components/Transaction';
import TransactionsList from './components/TransactionsList';
import PayrollIndex from './components/PayrollIndex';
import NewInjury from './components/NewInjury';
import InjuriesList from './components/InjuriesList';
import Injury from './components/Injury';
import UsersList from './components/UsersList';
import User from './components/User';
import MessageList from './components/MessageList';
import PayrollTransactionsList from './components/PayrollTransactionsList';
import StandardPayslip from './components/StandardPayslip';
import PayrollSettings from './components/PayrollSettings';
import PayTypesList from './components/PayTypesList';
import PayratesList from './components/PayratesList';
import AdditionsList from './components/AdditionsList';
import PayrunList from './components/PayrunList';
import CurrentPayslip from './components/CurrentPayslip';
import TimeAttendanceList from './components/TimeAttendanceList/TimeAttendanceList';
import Clockings from './components/Clockings';
import Clocking from './components/Clocking';
import TimeAttendanceIndex from './components/TimeAttendanceIndex';




function App() {
  
  pdfjs.GlobalWorkerOptions.workerSrc = PDFWORKER_URL
  
  return (
    <>
    <Routes>
    <Route path="/" element={<Layout/>}>

        <Route path='login' element={<Login/>}/>
        <Route path='logout'/>
        <Route path='register' element={<Register/>}/>

        <Route element={<RequireAuth/>}>
        <Route path='/' element={<Home/>}/>
        <Route path='/:id' element={<EmployeesList/>}/>
        <Route path='/:id/:playerid' element={<EmployeesList/>}/>
        <Route path='/Payroll' element={<PayrollIndex/>}/>
        <Route path='/PayrollSettings' element={<PayrollSettings/>}/>
        <Route path='/PayTypesList' element={<PayTypesList/>}/>
        <Route path='/PayratesList' element={<PayratesList/>}/>
        <Route path='/TimeAttendanceIndex' element={<TimeAttendanceIndex/>}/>
        <Route path='/TimeAttendanceList' element={<TimeAttendanceList/>}/>
        <Route path='/Clockings' element={<Clockings/>}/>
        <Route path='/Clocking/:id' element={<Clocking/>}/> 
        <Route path='/AdditionsList' element={<AdditionsList/>}/>
        <Route path='/PayrunList' element={<PayrunList/>}/>
        <Route path='/CurrentPayslip/:id' element={<CurrentPayslip/>}/>
        <Route path='/upload' element={<Upload/>}/>
        <Route path='/employee/:id' element={<Employee/>}/>
        <Route path='/pdfview/:id/:type/:pickedfilename' element={<PdfView/>}/>
        <Route path='/DocumentsList' element={<DocumentsList/>}/>
        <Route path='/StockControl' element={<Stock/>}/>
        <Route path='/StockitemsList' element={<StockitemsList/>}/>
        <Route path='/UsersList' element={<UsersList/>}/>
        <Route path='/stockitem/:id' element={<Stockitem/>}/>
        <Route path='/StandardPayslip/:id' element={<StandardPayslip/>}/>
        <Route path='/WarehouseList' element={<WarehouseList/>}/>
        <Route path='/warehouse/:id' element={<Warehouse/>}/>
        <Route path='/TransactionList' element={<TransactionsList/>}/>
        <Route path='/PayrollTransactionsList' element={<PayrollTransactionsList/>}/>
        <Route path='/Transaction/:transactiontype/:stockitem' element={<Transaction/>}/>
        <Route path='/InjuriesList' element={<InjuriesList/>}/>
        <Route path='/Injury/:id' element={<Injury/>}/>
        <Route path='/User/:id' element={<User/>}/>
        <Route path='/MessageList' element={<MessageList/>}/>

        <Route path='/addNewEmployee' element={<NewEmployee/>}/>
        <Route path='/addNewInjury/:id' element={<NewInjury/>}/>
        <Route path='/addNewStockitem' element={<NewStockitem/>}/>
        <Route path='/addNewWarehouse' element={<NewWarehouse/>}/>

        </Route>


        </Route>
    </Routes>
   
    
    </>
  );
}

export default App;
